import React from 'react';
import './Splash.css';
import AmbientStage from '../components/AmbientStage';
import RotatingDisc from '../components/RotatingDisc';
import logo from '../assets/logo.png';
import arrowIcon from '../assets/arrow.png';

function Splash({ goNext }) {
  return (
    <AmbientStage className="splash-screen">
      <strong className="vertical-word">TEXTILE</strong>
      <RotatingDisc />

      <div className="top-brand">
        <img src={logo} alt="Exhibition logo" />
        <span>April 20-23 / Cairo</span>
      </div>

      <div className="hero-content">
        <p className="eyebrow">Egypt International Exhibition</p>
        <h1>Garment & Textile Machinery</h1>
        <p>
          A mobile pass for industrial demos, buyer meetings, tickets, maps, and
          everything happening across the exhibition floor.
        </p>
      </div>

      <div className="glass-panel">
        <span>2026 Edition</span>
        <strong>Where garment innovation meets industrial scale.</strong>
        <div className="meter"><i /></div>
      </div>

      <button className="gold-action enter-action" onClick={goNext} type="button">
        Enter
        <img src={arrowIcon} alt="" aria-hidden="true" />
      </button>
    </AmbientStage>
  );
}

export default Splash;
